// boolean return if the index supplied has children
export function hasChildren(items, indexToCheck){
    if(indexToCheck + 1 >= items.length || items[indexToCheck+1].topic_parent_id == null) return false
    return  items[indexToCheck+1].topic_parent_id == items[indexToCheck].id || items[indexToCheck+1].topic_parent_id == indexToCheck
}